/**
 * @desc 获取登录用户对应的基地及以上信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryBaseInfoResponse>>> {
  return defHttp.get({
    url: '/web/base/loginTreeBaseInfos',
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.QueryBaseInfoResponse>>> {
  return defHttp.get({
    url: '/mock/web/base/loginTreeBaseInfos',
  });
}
